import {
  countryTLDMatching,
  domainIDMatching,
  partnerToProviderMatching,
} from "helpers/holidu";
import { dispatch, getState } from 'services/store';
import moment from 'moment';
import queryString from 'querystring';
import { requestRecommendations } from 'actions/recommendation-actions';
import { saveRecentlyViewed } from 'actions/recentlyViewedAction';
import { trackClickout } from 'services/tracking';
import uuid4 from 'helpers/crypto';

export function openClickout(partnerId, subsectionId, sectionId, props) {
  const state = getState();
  const { establishment, establishmentsSortType, index, establishmentOrder, establishmentId } = props;
  const allPartners = props.allPartners || props.partners;
  const transactionId = uuid4();
  const url = generateClickoutURL(partnerId, Object.assign({}, props, { transactionId }));
  if (!url) return null;
  dispatch(saveRecentlyViewed(establishment.id));
  setTimeout(() => dispatch(requestRecommendations(state.loggerReducer.userId, Object.keys(state.establishments).map(k => Number(k)))), 2000);
  trackClickout(Object.assign({}, props, {
    allPartners,
    cheapestPartner: partnerId,
    clickPos: Number.isNaN(index) || sectionId === 2 ? -1 : index,
    establishment,
    establishmentOrder,
    establishmentsSortType,
    id: establishment ? establishment.id : establishmentId,
    partners: establishment.partners,
    sectionId,
    subSectionId: subsectionId,
    transactionId,
  }));

  return window.open(url, '_blank');
}

export function generateClickoutURL(partnerId, props, isHref, searchApplied) {
  const { COUNTRY_CODE } = global.hr.intl;

  const state = getState();
  const { establishment } = props;
  const externailId = establishment && establishment.partners.find(partner => partnerId === partner.partner_id).external_id;
  const { dateArrival, dateLeaving, guestsNumber } = searchApplied || state.searchApplied;

  const query = {
    domainId: domainIDMatching[COUNTRY_CODE],
  };

  if (dateArrival && dateLeaving) {
    query.from = moment(dateArrival).format('YYYY-MM-DD');
    query.to = moment(dateLeaving).format('YYYY-MM-DD');
  }

  if (guestsNumber) {
    query.guests = guestsNumber;
  }

  if (partnerId in partnerToProviderMatching) {
    query.provider = partnerToProviderMatching[partnerId];
  }

  return `//holidu.${countryTLDMatching[COUNTRY_CODE]}/goto-e/${externailId}?${queryString.stringify(query)}`;
}
